// extracted by mini-css-extract-plugin
module.exports = {"Login":"_2jPR_crNUY7722UWTZSsHJ","Info":"c8h6thgUhVq94Cjt4gLIp"};